<div class="mac-custom-clr-modal">
	<button [disabled]="disableCloseButton" class="btn btn-icon XCclosing-button" aria-label="cancel" mat-dialog-close>
		<cds-icon shape="times"></cds-icon>
	</button>
	<ng-content></ng-content>
</div>
